/**
 * Created by Andrey Popov on 03.11.2023
 */

const CrazySocial = function () {
    Social.call(this, connector.CRAZY, {
        sdk: SdkManager.SDK_CRAZY
    });
};

CrazySocial.prototype = Object.create(Social.prototype);
CrazySocial.prototype.constructor = CrazySocial;

CrazySocial.prototype._connect = function (callback) {
    if (!this.hasAuthListener) {
        CrazyGames.SDK.user.addAuthListener(() => {
            if (!this.isConnected() || this.loginRunning) {
                return;
            }

            this.loadUser(() => {
                if (this.isLoggedIn()) {
                    this.onLogin();
                }
            });
        });

        this.hasAuthListener = true;
    }

    this.loadUser(() => {
        callback(connector.STATUS_CONNECTED);
    });
};

CrazySocial.prototype._login = function (cb) {
    this.loginRunning = true;

    const callback = function () {
        this.loginRunning = false;
        cb();
    }.bind(this);

    CrazyGames.SDK.user.showAuthPrompt()
        .then(() => {
            this.loadUser(callback);
        })
        .catch((error) => {
            console.log("CrazySocial login error:", error);

            callback();
        });
};

CrazySocial.prototype.loadUser = function (callback) {
    if (this.isLoggedIn()) {
        callback();
        return;
    }

    CrazyGames.SDK.user.getUserToken()
        .then((token) => {
            ConnectorRestClient.get(
                `/crazy/decodetoken/${token}`,
                {},
                (response) => {
                    this.accessToken = token;
                    this.user = CrazySocial.formatUserData(response);
                    callback();
                },
                (error) => {
                    callback(error);
                }
            );
        })
        .catch((error) => {
            console.log("CrazyGames getUserToken error:", error);
            callback(error);
        });
};

CrazySocial.formatUserData = function (userData) {
    if (!userData.userId) {
        return undefined;
    }

    return {
        id: `${userData.userId}`,
        name: userData.username,
        firstName: userData.username,
        avatar: userData.profilePictureUrl
    };
};

CrazySocial.prototype._aboutMe = function (callback) {
    if (this.user) {
        callback(connector.CODE_SUCCEED, this.user);
    } else {
        callback(connector.CODE_FAILED);
    }
};

CrazySocial.prototype.markAchievement = function () {
    CrazyGames.SDK.game.happytime();
};

CrazySocial.prototype.getAccessToken = function () {
    return `CRAZY_${this.accessToken}`;
};

CrazySocial.prototype.isLoggedIn = function () {
    return Boolean(this.user);
};

CrazySocial.prototype._getUserID = function () {
    return this.user && this.user.id;
};